// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"441":"lang-en","799":"lang-it"}[chunkId] || chunkId) + "." + {"67":"a47afea7","96":"aa697c97","167":"4aba0487","275":"17718a57","345":"f5144cbd","416":"a480bfe3","441":"4c665278","447":"d51240d8","636":"efde8943","747":"c974746f","799":"ec615196","982":"3dce27b7"}[chunkId] + ".chunk.js";
};